// extracted by mini-css-extract-plugin
module.exports = {"removeButton-spacingCI":"Admin-ManageAccounts-___stylesManageAccounts__removeButton-spacingCI___2kW-a","button-spacing":"Admin-ManageAccounts-___stylesManageAccounts__button-spacing___3OMVl","closeBtn":"Admin-ManageAccounts-___stylesManageAccounts__closeBtn___1wEgV","space-fix":"Admin-ManageAccounts-___stylesManageAccounts__space-fix___ppspI"};
    if(module.hot) {
      // 1752586164618
      var cssReload = require("/builds/SilverAgent/SilverAgent/ui-parent-r2/silveragent-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"build/","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  